import { DashboardPageBody } from "../../components/Page";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import MailSettingsPage from "./ui";

const MailSettings = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <MailSettingsPage />
      </DashboardPageBody>
    </DashboardLayout>
  );
};

export default MailSettings;
